<template>
    <li class="d-md-none">
        <a class="nav-link" :href="$routing('pannier')">
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.4045 4.32291L18.405 4.32117C18.435 4.20113 18.5743 4.10889 18.7186 4.14497C18.8384 4.17492 18.9305 4.31367 18.8951 4.45764C18.895 4.45797 18.8949 4.4583 18.8948 4.45863L17.0795 11.5603C17.0365 11.6834 16.9209 11.7599 16.8199 11.7599H6.9799H6.34126L6.49451 12.3799L6.93451 14.1599L7.02845 14.5399H7.4199H15.6199C15.7638 14.5399 15.8799 14.656 15.8799 14.7999C15.8799 14.9438 15.7638 15.0599 15.6199 15.0599H6.8399C6.71007 15.0599 6.61304 14.9777 6.58661 14.8654L6.58663 14.8654L6.58552 14.8608L3.50551 2.30082L3.41211 1.9199H3.0199H1.1599C1.01604 1.9199 0.899902 1.80376 0.899902 1.6599C0.899902 1.51604 1.01604 1.3999 1.1599 1.3999H3.5999C3.72974 1.3999 3.82676 1.48209 3.85319 1.59442L3.85317 1.59443L3.8544 1.59944L6.1344 10.8594L6.22808 11.2399H6.6199H16.2599H16.6488L16.7445 10.8629L18.4045 4.32291Z" fill="white" stroke="white"/>
                <path d="M8.9798 17.3999C8.9798 17.7976 8.65744 18.1199 8.25979 18.1199C7.86215 18.1199 7.53979 17.7976 7.53979 17.3999C7.53979 17.0023 7.86215 16.6799 8.25979 16.6799C8.65744 16.6799 8.9798 17.0023 8.9798 17.3999Z" fill="white" stroke="white"/>
                <path d="M15.0298 17.3999C15.0298 17.6595 14.8194 17.8699 14.5598 17.8699C14.3003 17.8699 14.0898 17.6595 14.0898 17.3999C14.0898 17.1404 14.3003 16.9299 14.5598 16.9299C14.8194 16.9299 15.0298 17.1404 15.0298 17.3999Z" fill="white" stroke="white" stroke-width="1.5"/>
            </svg>
            <span class="badge badge-pill badge-danger badge-up">{{ count }}</span>
        </a>
    </li>
</template>

<script>
    var $this;
    import { EventBus } from '../../helpers/shared'
    export default {
        name: "mdLink",
        data: () => ({
            baskets: [],
            count: 0
        }),
        mounted() {
            //const element = JSON.parse(localStorage.getItem('carts'));
            let carts = this.$storage.getItem('carts');
            if (typeof carts !== 'undefined'){
                const element = JSON.parse(this.$storage.decryptString(this.$storage.getItem('carts')))
                if (Array.isArray(element)){
                    this.baskets = element;
                    this.count = this.baskets.length;
                }
            }else{
                this.$storage.setItem('carts',this.$storage.encryptString(JSON.stringify([])))
            }
            EventBus.$on('remove', this.removeBasket);
            EventBus.$on('addBasket', this.addBasket);
        },
        methods:{
            removeBasket() {
                this.count --;
            },
            addBasket() {
                this.count ++;
            }
        },
        created(){
            $this = this;
        }
    }
</script>

<style scoped>

</style>
